import { deleteDoc, doc, getDocs, collection } from "firebase/firestore";
import { useEffect, useState } from "react";
import AddRedirect from "./AddRedirect";
import { auth, db } from "./firebaseconfig";
import { Link } from "react-router-dom";

function User() {
  const [redirects, setRedirects] = useState();
  const [addRedirect, setAddRedirect] = useState(false);

  const getRedirects = async () => {
    const docRef = collection(db, "urls");
    const docSnapshots = await getDocs(docRef);
    const data = docSnapshots.docs.map((doc) => ({
      ...doc.data(),
      id: doc.id,
    }));
    setRedirects(data);
  };

  const removeItem = async (e) => {
    const short = e.target.parentNode.parentElement.id;

    const urlRef = doc(collection(db, "urls"), short);
    await deleteDoc(urlRef);

    setRedirects((prev) => {
      const newRedirects = { ...prev };
      delete newRedirects[short];
      return newRedirects;
    });
  };

  useEffect(() => {
    getRedirects();
  }, []);

  return (
    <>
      <div id="user-container">
        <h2>{auth.currentUser.displayName}</h2>
        {redirects &&
          redirects.map((redirect) => {
            return (
              <div id={redirect.id} key={redirect.id}>
                <p className="url-container">
                  <a
                    target="_blank"
                    className="short-url"
                    href={window.location.origin + "/admin/" + redirect.id}
                    style={{ textDecoration: "none", color: "black" }}
                  >
                    {window.location.origin}/{redirect.id}
                  </a>
                  <span className="bin" onClick={(e) => removeItem(e)}>
                    🗑️
                  </span>
                </p>
              </div>
            );
          })}
        <button
          onClick={() => setAddRedirect(true)}
          className="add-redirect-btn"
        >
          ADD
        </button>
      </div>
      {addRedirect && <AddRedirect />}
    </>
  );
}

export default User;
